import { render } from "./Order-Enquiry.vue?vue&type=template&id=1af41d86&scoped=true"
import script from "./Order-Enquiry.vue?vue&type=script&lang=js"
export * from "./Order-Enquiry.vue?vue&type=script&lang=js"

import "./Order-Enquiry.vue?vue&type=style&index=0&id=1af41d86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af41d86"]])

export default __exports__